import FilterItem from "./FilterItem";
import styles from "../styles/FilterActivity.module.scss";
import React, { useState } from "react";

export default function FilterActivity() {
  const [category, filterCategory] = useState({
    Events: false,
    "Restaurant Promotions": false,
    "Lifestyle Applications": false,
  });

  function handleInputChange(event) {
    const newCategory = { ...category };
    const target = event.target;
    newCategory[target.name] = target.checked;

    filterCategory({ ...newCategory });
  }

  return (
    <div className={styles.main}>
      <FilterItem
        name={"category"}
        choices={category}
        handleInputChange={(event) => {
          handleInputChange(event);
        }}
      ></FilterItem>
    </div>
  );
}
